import './cart.css';
import { CartIcon } from "../../assets/icons/CartIcon";
import { CloseIcon } from "../../assets/icons/CloseIcon";
import { useCart } from "../../context/CartContext";
import { CartTotal } from '../CartTotal/CartTotal';
import { CartItem } from '../CartItem/CartItem';
import { CouponInput } from '../CouponInput/CouponInput';
import { UtensilsInput } from '../UtensilsInput/UtensilsInput';
import { BarLoader } from '../BarLoader/BarLoader';
import { useState } from 'react';
import { DeliveryMethod } from '../../Enum/DeliveryMethod';
import { PaymentMethod } from '../../Enum/PaymentMethod';
import { useServer } from '../../context/ServerContext';
import { checkoutEndpoints } from '../../env';

const paymentMethods = {
    CASH: 'cash',
    ZELLE: 'zelle',
    CASHAPP: 'cashapp',
    CREDIT_DEBIT: 'credit_debit_card'
}

export const Cart = () => {
    //HOOKS
    const { postRequest } = useServer();
    const { cart, cartOpen, setCartOpen, finishOrderOpen, setFinishOrderOpen, getCartToken } = useCart();

    //STATES
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(paymentMethods.CASH);
    const [loading, setLoading] = useState(false);
    const [checkoutError, setCheckoutError] = useState("");
    
    //FUNCTIONS
    const handleFinishOrder = () => {
        if (loading)
        {
            return;
        }

        setLoading(true);
        setCheckoutError("");

         let data = {
            cart_token: getCartToken(),
            delivery: {
                type: DeliveryMethod.PICKUP
            },
            name: selectedPaymentMethod,
            lastname : ".",
            email : "n/a",
            phone : "n/a",
            tip: 0,
            payment: {
                type: PaymentMethod.CASH,
            },
            platform: "web",
        }

        
        postRequest(checkoutEndpoints.post_order, data, (res) => {
            setLoading(false);

            if (res[0])
            {
                res = res[1];
                if (res.success)
                {
                    window.location.reload();
                }
                else
                {
                    setCheckoutError("Server error, please try again in a bit.");
                }
            }
            else
            {
                setCheckoutError("Server error, please try again in a bit.");
            }
        });
    }

    return (
        <>
            <div className={cartOpen ? 'cart_modal_container active' : 'cart_modal_container'}>
                <div className='cart_container'>
                    <button className='close' onClick={() => setCartOpen(false)}>
                        <CloseIcon />
                    </button>
                    <div className='header'>
                        <CartIcon />
                        <h2>
                            Your order
                        </h2>
                    </div>
                    <div className='items_container'>
                        {cart && cart.items.map ((item) => {
                            return <CartItem item={item} key={'cart_item_' + item.id} />
                        })}
                    </div>
                    <hr/>
                    <CouponInput />
                    <UtensilsInput />
                    <CartTotal />
                </div>
            </div>

            <div className={finishOrderOpen ? 'finish_order_modal_container active' : 'finish_order_modal_container'}>
                <div className='finish_order_container'>
                    <div className='header'>
                        <h2>
                            Finish the order
                        </h2>
                        <button className='close' onClick={() => setFinishOrderOpen(false)} disabled={loading}>
                            <CloseIcon />
                        </button>
                    </div>
                    <div className='body'>
                        <h2>
                            Payment method
                        </h2>
                        <div className='payment_methods'>
                            <div className={selectedPaymentMethod === paymentMethods.CASH ? 'item active' : 'item'} onClick={() => setSelectedPaymentMethod(paymentMethods.CASH)}>
                                Cash
                            </div>
                            <div className={selectedPaymentMethod === paymentMethods.ZELLE ? 'item active' : 'item'} onClick={() => setSelectedPaymentMethod(paymentMethods.ZELLE)}>
                                Zelle
                            </div>
                            <div className={selectedPaymentMethod === paymentMethods.CASHAPP ? 'item active' : 'item'} onClick={() => setSelectedPaymentMethod(paymentMethods.CASHAPP)}>
                                Cashapp
                            </div>
                            <div className={selectedPaymentMethod === paymentMethods.CREDIT_DEBIT ? 'item active' : 'item'} onClick={() => setSelectedPaymentMethod(paymentMethods.CREDIT_DEBIT)}>
                                Credit / Debit Card
                            </div>
                        </div>

                        <span className='error_message'>
                            {checkoutError}
                        </span>
                    </div>
                    <div className='footer'>
                        {
                            loading && (
                                <div className='loader'>
                                    <BarLoader />
                                </div>
                            )
                        }
                        <div>

                        </div>
                        <div className='actions'>
                            <button className='light_btn secundary' onClick={() => setFinishOrderOpen(false)} disabled={loading}>
                                Cancel
                            </button>
                            <button className='light_btn' onClick={handleFinishOrder} disabled={loading}>
                                Finish Order
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}